// import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
// import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// import { ActivatedRoute } from '@angular/router';
// import { MessageService } from 'primeng/api';
// import { environment } from '../../../environments/environment';
// import { ApiService } from '../../services/api.service';
// import { Subscription } from 'rxjs';
// import { TransHeaderSteperComponent } from '../../components/trans-header-steper/trans-header-steper.component';
// import { Table } from 'primeng/table';
// import { NeedGenrationComponent } from '../stape-component/need-genration/need-genration.component';
// import { RFiComponent } from '../stape-component/rfi/rfi.component';
// import { VendorComponent } from '../stape-component/vendor/vendor.component';
// import { DraftSocComponent } from '../stape-component/draft-soc/draft-soc.component';
// import { VcnsApprovalComponent } from '../stape-component/vcns-approval/vcns-approval.component';
// import { AIPComponent } from '../stape-component/aip/aip.component';
// import { ReceiptMomComponent } from '../stape-component/receipt-mom/receipt-mom.component';
// import { ConstituteCommitteeComponent } from '../stape-component/constitute-committee/constitute-committee.component';
// import { FeasibiltyStudyComponent } from '../feasibilty-study/feasibilty-study.component';
// import { PsqrComponent } from '../psqr/psqr.component';
// import { AONComponent } from '../stape-component/aon/aon.component';
// import { EOIComponent } from '../stape-component/eoi/eoi.component';
// import { PreRfpMeetingComponent } from '../stape-component/pre-rfp-meeting/pre-rfp-meeting.component';
// import { FirmResponseSubmissionComponent } from '../firm-response-submission/firm-response-submission.component';
// import { IdexPrototypeComponent } from '../idex-prototype/idex-prototype.component';
// import { SsctComponent } from '../ssct/ssct.component';
// import { StaffEvaluationComponent } from '../staff-evaluation/staff-evaluation.component';
// import { PsqrToSqrComponent } from '../psqr-to-sqr/psqr-to-sqr.component';
// import { IdexCommercialRfpComponent } from '../idex-commercial-rfp/idex-commercial-rfp.component';
// import { CommercialNegocatitionComponent } from '../stape-component/commercial-negocatition/commercial-negocatition.component';


// @Component({
//   selector: 'app-make-ii-transaction',
//   standalone: false,
//   templateUrl: './make-ii-transaction.component.html',
//   styleUrl: './make-ii-transaction.component.scss'
// })
// export class MakeIiTransactionComponent implements OnInit , OnDestroy{
// @ViewChild('dt') documentTable!: Table;
// @ViewChild(TransHeaderSteperComponent) transHeaderSteperComponent?: TransHeaderSteperComponent;
// @ViewChild(NeedGenrationComponent) needGenrationComponent?: NeedGenrationComponent;
// @ViewChild(RFiComponent) rfiComponent?: RFiComponent;
// @ViewChild(VendorComponent) vendorComponent?: VendorComponent;
// @ViewChild(DraftSocComponent) draftSocComponent?: DraftSocComponent;
// @ViewChild(VcnsApprovalComponent) vcnsApprovalComponent?: VcnsApprovalComponent;
// @ViewChild(AIPComponent) aip?: AIPComponent;
// @ViewChild(ReceiptMomComponent) receiptMomComponent?: ReceiptMomComponent;
// @ViewChild(ConstituteCommitteeComponent) constituteCommitteeComponent?: ConstituteCommitteeComponent;
// @ViewChild(FeasibiltyStudyComponent) feasibiltyStudyComponent?: FeasibiltyStudyComponent;
// @ViewChild(PsqrComponent) psqrComponent?: PsqrComponent;
// @ViewChild(AONComponent) aonComponent?: AONComponent;
// @ViewChild(EOIComponent) eoiComponent?: EOIComponent;
// @ViewChild(PreRfpMeetingComponent) preRfpMeetingComponent?: PreRfpMeetingComponent;
// @ViewChild(FirmResponseSubmissionComponent) firmResponseSubmissionComponent?: FirmResponseSubmissionComponent;
// @ViewChild(IdexPrototypeComponent) idexPrototypeComponent?: IdexPrototypeComponent;
// @ViewChild(SsctComponent) ssctComponent?: SsctComponent;
// @ViewChild(StaffEvaluationComponent) staffEvaluationComponent?: StaffEvaluationComponent;
// @ViewChild(PsqrToSqrComponent) psqrToSqrComponent?: PsqrToSqrComponent;
// @ViewChild(IdexCommercialRfpComponent) idexCommercialRfpComponent?: IdexCommercialRfpComponent;
// @ViewChild(CommercialNegocatitionComponent) commercialNegocatitionComponent?: CommercialNegocatitionComponent;
//  proposalId: any;
//    steps: any;
//    activeIndex = 1;
//    stapName: any;
//    userGuide: string;
//    routeList = [];
//    MasterData: any;
//    apiUrl = environment.APIUrl;
//    proposalName: any;
//    route_cols: any[] = [
//      { field: 'user.first_name', header: 'First Name', filterType: 'text' },
//      { field: 'user.last_name', header: 'Last Name', filterType: 'text' },
//      { field: 'proposal_step.name', header: 'Proposal Step Name', filterType: 'text' },
//      { field: 'role.name', header: 'Role', filterType: 'text' },

//    ];
//    visible = false;
//    private subscriptions = new Subscription();
//    winner: any;
//    roleList = []
//    userList = []
//    proposalData: any;
//    routeForm: FormGroup;
//    stagesList: any[] = []
//    reportList: any[] = []
//    DocName: string;
//    pdfdata: any;
//    displayDialog: boolean = false;
//    phaseId:any;
//    schemeId: any;
//   userID: any;
//   navigate_Step:any;
//     unitList=[];
//   userListCopy =[]
//   filteredRouteList: any;
//    filteredSteps: any;
//     unitListN: any;
//   schemeName:string='Make II';
//     tabList: any;
//   activeTabIndex: any;
//   activePhaseId: any;
//   selectedPhaseId: any;
//   currentPage: number;
//   topRender=true;
//   searchText: string = ''
//   baseUrl = environment.APIUrl;
//   confirmChecked = false;
//    constructor(private api: ApiService, private route: ActivatedRoute, private messageService: MessageService, private fb: FormBuilder,) { 
//           const role = sessionStorage.getItem('user_role_id');
//     this.userID = role
//    }

//    ngOnInit(): void {
//      this.route.queryParams.subscribe(params => {
//        const id = params['id'];
//        const proposalName = params['name'];
//        const phase = params['phase'];
//         const scheme = params['scheme'];
//          const step = params['step'];
//        this.navigate_Step = step;
//       this.schemeId = scheme;
//        this.proposalId = id;
//        this.proposalName = proposalName;
//        this.phaseId = phase

//      });
//         this.routeForm = this.fb.group({
//   step: [null, Validators.required],
//   role: [null, Validators.required],
//   user: [null, Validators.required],
//   // unit: [null, Validators.required],
//   level: [null, Validators.required],
//   approved: [false]
// });
//      this.getSteps();
//      this.ongetmasterData();
//      // this.getpermDetails();
//      this.onUserGuide('process')
//      this.getTabs()
//    }
//    ngOnDestroy() {
//      this.subscriptions.unsubscribe();
//    }
//    getSteps() {
//      const sub = this.api.getAPI(`/transaction/proposals/${this.proposalId}/steps/`).subscribe(res => {
//        this.steps = res;
//       this.filteredSteps = this.steps?.filter(s => !s.skipped) || [];
//        const index = res.findIndex(item => item.id == this.navigate_Step) || 0;
//       if (index == -1) {
//         this.stapName = res[0];
//         this.step_details = res[0]; // Set step_details immediately
//         this.activeIndexCode = res[0].code
//         console.log("stapName from if",this.stapName);
//       } else {
//         this.stapName = res[index];
//         this.step_details = res[index]; // Set step_details immediately
//         this.activeIndexCode = res[index].code
//         console.log("stapName from else",this.stapName);
//       }
//        this.onActiveIndexChange(this.stapName)
//         // this.getUsers();
//       //  this.getpermDetails()
//      })
//      this.subscriptions.add(sub);
//    }
//    activeIndexCode: any = 'makeI_01'
//    onActiveIndexChange(event: any) {
//      this.activeIndex = event.sequence;
//      this.activeIndexCode = event.code
//      this.stapName = event;
//      this.step_details = event; // Set step_details immediately for template rendering
//      this.onUserGuide('process');
//       this.getUsers();
//        this.getworkflowlogs()
//      this.getpermDetails();
//    }
//  goToNextStep() {
//    const currentIndex = this.steps.findIndex(step => step.code === this.activeIndexCode);
//    const nextStep = this.steps.slice(currentIndex + 1).find(step => !step.skipped);

//    if (nextStep) {
//      // //console.log('Navigating to next step:', nextStep.sequence, nextStep.code);
//      // Delay to prevent double triggering
//      setTimeout(() => {
//        this.onActiveIndexChange(nextStep);
//      }, 0);
//    } else {
//      console.warn('No next step found.');
//    }
//  }
//    onUserGuide(event: string) {
//      this.userGuide = event;

//      if (this.userGuide == 'user') {
//        this.getUsers();
//      }
//    }
//   getUsers() {
//     this.routeList = [];
//     const sub = this.api
//       .getAPI(`/transaction/proposal-workflow/?proposal_step_id=${this.stapName.id}`)
//       .subscribe((res: any) => {
//         this.getLogs()
//         const usersMap = new Map();
//         const sortedData = res.data.sort((a: any, b: any) => a.sequence - b.sequence);

//         for (const item of sortedData) {
//           const userId = item.user?.id;
//           const roleId = item.role?.id;
//           if (userId && roleId) {
//             const compositeKey = `${userId}_${roleId}`;
//             if (!usersMap.has(compositeKey)) {
//               usersMap.set(compositeKey, item);
//             }
//           }
//         }

//         this.routeList = Array.from(usersMap.values());
//          this.filteredRouteList = this.routeList.filter(member => 
//     member.role.name !== 'Commenter'
//   );
//       });

//     this.subscriptions.add(sub);
//   }
//   currentMatch: any = null;
// // Component methods
// getLogs() {
//   this.api.getAPI(`/transaction/proposal-workflow-log/${this.stapName.id}/`)
//     .subscribe((res: any) => {
//       this.currentMatch = res.current_step;
//       // this.cdr.detectChanges();
//     });
// }

// // These methods should exist in your component
// get matchedIndex(): number {
//   if (!this.currentMatch) return -1;
//   return this.filteredRouteList.findIndex(member => 
//     member.user?.id === this.currentMatch.user?.id && 
//     member.role?.id === this.currentMatch.role?.id
//   );
// }

// isInProgressPath(member: any, index: number): boolean {
//   const matchIdx = this.matchedIndex;
//   return matchIdx >= 0 && index <= matchIdx;
// }

// isConnectorActive(index: number): boolean {
//   const matchIdx = this.matchedIndex;
//   return matchIdx >= 0 && index < matchIdx;
// }

// // Check if connector should be active (before matched index)
// isConnectorInProgressPath(index: number): boolean {
//   const matchIdx = this.matchedIndex;
//   return matchIdx >= 0 && index < matchIdx;
// }

// // Only show connector if not last and next isn't Commenter
// shouldShowConnector(member: any, index: number, last: boolean): boolean {
//   if (last || member.role.name === 'Commenter') return false;
//   const nextItem = this.routeList[index + 1];
//   return !(nextItem && nextItem.role.name === 'Commenter');
// }
//    // user configration

//    editeRoute() {
//      this.visible = true;
//      this.getRoleList();
//       this.getUnit()
//      this.getUserList();
//      const sub = this.api.getAPI(`/transaction/proposals/${this.proposalId}/steps/?skipped=False&phase_id=${this.phaseId}`).subscribe((res: any) => {
//        this.stagesList = res
//        this.routeForm.get('step')?.setValue(this.stapName.id);
//        this.getProposalWorkflow(this.stapName.id);
//      });
//      this.subscriptions.add(sub);
//    }
//    getProposalWorkflow(id: any) {
//      this.proposalData = [];
//      const sub = this.api.getAPI(`/transaction/proposal-workflow/?proposal_step_id=${id}`).subscribe((res: any) => {
//        // //console.log(res)
//        this.proposalData = res.data;
//      });
//    }

// onrouteFormSubmit() {
//     if (this.routeForm.invalid) return;

//     this.routeForm.get('step')?.setValue(this.stapName.id);

//     const formValue = this.routeForm.value;
//     const selectedUser = this.userList.find(u => u.id === formValue.user);

//     const payload = {
//       status: 1,
//       sequence: this.routeForm.get('level')?.value, // Convert level input to number
//       proposal_step: formValue.step,
//       user: formValue.user,
//       role: formValue.role,
//        unit: selectedUser ? selectedUser.unit?.id : null,
//       is_final_approve: formValue.approved === true
//     };
//     const sub = this.api.postAPI(`/transaction/proposal-workflow/`, payload).subscribe({
//       next: (res: any) => {
//         // this.api.getAPI(`/transaction/proposal-workflow?proposal_step_id=${formValue.step}`).subscribe((res: any) => {
//         //   this.proposalData = res;
//         //   this.visible = false;

//         // });
//         this.visible = false;
//         this.getUsers();
//         this.routeForm.reset();
//         // this.addProposalVisible = false;
//       },
//       error: (err) => {
//         console.error('Update failed:', err);
//         this.messageService.add({
//           severity: 'error',
//           summary: 'Error',
//           detail: err?.error?.detail || 'Something went wrong while updating the mapping.',
//         });
//       }
//     });
//     this.subscriptions.add(sub);
//   }
//   getRoleList() {
//    const sub = this.api.getAPI('/access/user-roles/').subscribe((res: any) => {
//       let rolePriority
//       if (this.isIRA) {
//         rolePriority = ['REC', 'APP']
//       } else {
//         rolePriority = ['INT', 'REC', 'APP'];  // desired order
//       }
//       const resp = res.data;

//       // Filter and sort
//       this.roleList = resp
//         .filter(role => rolePriority.includes(role.code))
//         .sort((a, b) => rolePriority.indexOf(a.code) - rolePriority.indexOf(b.code));
//     });
//   }
//   getUserList() {
//     const sub = this.api.getAPI('/account/users/').subscribe((res: any) => {
//       this.userList = res.data;
//       this.userListCopy = [...this.userList]
//     })
//     this.subscriptions.add(sub);
//   }
//     getUnit() {
//      let currentUnitId  = sessionStorage.getItem('unit_id');
//     const sub = this.api.getAPI('/master/units/').subscribe((res: any) => {
//       this.unitList = res.data;
//       this.unitListN = res.data.filter((u: any) => u.id != Number(currentUnitId));
//     })
//     this.subscriptions.add(sub);
//   }
//     onRoleChange(event: any) {
//     // this.roleID = event.value;
//     this.tryFetchingSequence();
//   }

//   onUserChange(event: any) {
//     // this.userID = event.value;
//     this.tryFetchingSequence();
//   }
//     onUnitChange(event: any) {
//     let unit_id = event.value
//     this.userList = this.userListCopy.filter(user => user.unit?.id == unit_id);
//   }
//     tryFetchingSequence() {
//       const step = this.routeForm.get('step').value;
//       const role = this.routeForm.get('role').value;
//       const user = this.routeForm.get('user').value;
//     if (step && role && user) {
//       this.getSequence();
//     }
//   }

//   getSequence() {
//      const step = this.routeForm.get('step').value;
//      const role = this.routeForm.get('role').value;
//      const user = this.routeForm.get('user').value;
//     const sub = this.api.getAPI(`/transaction/get-next-level/?proposal_step_id=${step}&role_id=${role}`)
//       .subscribe((res: any) => {
//         const sequenceValue = res.level ?? '';
//         this.routeForm.get('level')?.patchValue(sequenceValue);
//       });
//     this.subscriptions.add(sub);
//   }
//    onStepChange(event: any) {
//      const selectedStepId = event.value;
//      const sub = this.api.getAPI(`/transaction/proposal-workflow?proposal_step_id=${selectedStepId}`).subscribe((res: any) => {
//        this.proposalData = res

//      });
//      this.subscriptions.add(sub);
//    }

//    getReportList() {
//      this.reportList = []
//      const sub = this.api.getAPI(`/revenue/need/version-control/?proposal_step=${this.step_details.id}&proposal_step__proposal=${this.proposalId}`).subscribe((res: any) => {
//        this.reportList = res
//      });
//      this.subscriptions.add(sub);
//    }
//      documentList: any[] = []
//   // getDocumentList() {
//   //   this.documentList = []
//   //   const sub = this.api.getAPI(`/make1/dms/documents/${this.schemeId}/${this.proposalId}/`).subscribe((res: any) => {
//   //     this.documentList = this.prepareDocumentList(res)
//   //   });
//   //   this.subscriptions.add(sub);
//   // }
//     getDocumentList() {
//     this.documentList = []
//     const sub = this.api.getAPI(`/transaction/dms/files/?proposal_step__proposal=${this.proposalId}`).subscribe((res: any) => {
//       this.documentList = res.data
//     });
//     this.subscriptions.add(sub);
//   }
//  prepareDocumentList(data: any): any[] {
//   const docs: any[] = [];

//   // Need Generation
//   if (data.need_generation) {
//     docs.push({ name: 'Draft SOTR', url: data.need_generation.draft_sotr });
//     data.need_generation.need_files.forEach((file: any, index: number) => {
//       docs.push({ name: `Need File ${index + 1}`, url: file.file });
//     });
//   }

//   // AIP
//   if (data.aip?.document) {
//     docs.push({ name: 'AIP Document', url: data.aip.document });
//   }

//   // QA Agency
//   if (data.qa_agecy?.nomination_file?.length > 0) {
//     data.qa_agecy.nomination_file.forEach((file: any, index: number) => {
//       docs.push({ name: `QA Agency File ${index + 1}`, url: file.file });
//     });
//   }

//   // AON and SOC
//   if (data.aon_soc) {
//     if (data.aon_soc.aon) docs.push({ name: 'AON', url: data.aon_soc.aon });
//     if (data.aon_soc.soc) docs.push({ name: 'SOC', url: data.aon_soc.soc });
//   }

//   // Meeting MoMs
//   if (data.pre_rfp_meeting?.mom) {
//     docs.push({ name: 'Pre-RFP Meeting MoM', url: data.pre_rfp_meeting.mom });
//   }

//   if (data.pre_bid_meeting?.mom) {
//     docs.push({ name: 'Pre-Bid Meeting MoM', url: data.pre_bid_meeting.mom });
//   }

//   // Final Offer
//   if (data.final_offer?.offer) {
//     docs.push({ name: 'Final Offer', url: data.final_offer.offer });
//   }

//   // Drawings & Related Docs
//   if (data.drawings_documents) {
//     if (data.drawings_documents.drawing) {
//       docs.push({ name: 'Drawing File', url: data.drawings_documents.drawing });
//     }
//     if (data.drawings_documents.document) {
//       docs.push({ name: 'Document File (Drawings)', url: data.drawings_documents.document });
//     }
//   }

//   // QAP & ATP
//   if (data.qap_atp) {
//     if (data.qap_atp.qap) {
//       docs.push({ name: 'QAP File', url: data.qap_atp.qap });
//     }
//     if (data.qap_atp.document) {
//       docs.push({ name: 'ATP Document', url: data.qap_atp.document });
//     }
//   }

//   // FAT Report
//   if (data.fats_prototype?.fat_report) {
//     docs.push({ name: 'FAT Report', url: data.fats_prototype.fat_report });
//   }

//   // User Certificate
//   if (data.user_certificate?.certificated) {
//     docs.push({ name: 'User Certificate', url: data.user_certificate.certificated });
//   }

//   // Development Prototype
//   if (data.development_prototype?.file) {
//     docs.push({ name: 'Development Prototype', url: data.development_prototype.file });
//   }

//   // User Trials (Generic)
//   if (data.user_trials?.signed_documents) {
//     docs.push({ name: 'User Trials (Signed Docs)', url: data.user_trials.signed_documents });
//   }

//   // User Trials (Make)
//   if (data.user_trials_make?.signed_documents) {
//     docs.push({ name: 'User Trials (Make)', url: data.user_trials_make.signed_documents });
//   }

//   // Feasibility Study
//   if (data.feasibility_study?.file) {
//     docs.push({ name: 'Feasibility Study', url: data.feasibility_study.file });
//   }

//   // Bulk Production
//   if (data.bulk_production?.document) {
//     docs.push({ name: 'Bulk Production Document', url: data.bulk_production.document });
//   }

//   return docs;
// }

//     viewDocument(doc: any) {
//       //console.log(doc)
//       const url = environment.APIUrl + doc?.url;
//       window.open(url, '_blank');
//     }

//     downloadDocument(doc: any) {
//       const link = document.createElement('a');
//       link.href = environment.APIUrl + doc?.url; // adjust to your key
//       link.download = doc?.name || 'document';
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     }
//    IRA: any;
//    isIRA = false
//    IRAremarks: string;
//   onIRA(event: any) {
//     this.isIRA = true;
//     this.IRA = event;
//     if(this.step_details?.add_route_conf){
//      this.getRoleList();
//     this.getUnit()
//     this.getUserList();
//     const sub = this.api.getAPI(`/transaction/proposals/${this.proposalId}/steps/?skipped=False&phase_id=${this.phaseId}`).subscribe((res: any) => {
//       this.stagesList = res
//       this.routeForm.get('step')?.setValue(this.stapName.id);
//       this.getProposalWorkflow(this.stapName.id);
//     });
//     this.subscriptions.add(sub);
//   }
//     //console.log('ira', event)
//   }
//   //  submitIRA(ira_status: any) {
//   //    if (this.IRA === 'Initiate') {
//   //      //console.log(this.IRAremarks)
//   //    }
//   //    if (this.IRA === 'Approve') {
//   //      //console.log(this.IRAremarks)
//   //    }
//   //    if (this.IRA === 'Recommend') {
//   //      //console.log(this.IRAremarks)
//   //    }
//   //     if(this.stapName.add_route_conf){
//   //     this.onrouteFormSubmit()
//   //   }
//   //    let role_id = sessionStorage.getItem('user_role_id')
//   //    const payload = {
//   //      "proposal_step": this.stapName.id,
//   //      "role_id": role_id,
//   //      "is_approved": ira_status,
//   //      "remark": this.IRAremarks

//   //    }
//   //    this.isIRA = false;
//   //    this.IRAremarks = ''
//   //    const sub = this.api.postAPI(`/transaction/proposal-ira-action/`, payload).subscribe((res: any) => {
//   //      this.getpermDetails();
//   //      this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Proposal added successfully' });

//   //    })
//   //    this.subscriptions.add(sub);
//   //  }
//   //  submitIRA(): void {
//   //   if (!this.step_details?.id) return;
//   //   const payload = {
//   //     proposal_step: this.step_details.id,
//   //     approve_status: 1,
//   //     remark: '',
//   //     final_approval: this.confirmChecked ? 1 : 0
//   //   };
//   //   const sub = this.api.postAPI(`/transaction/copy/proposal-ira-action/`, payload).subscribe({
//   //     next: (res: any) => this.messageService.add({
//   //         severity: 'success', summary: 'Success', detail: res?.message || 'Proposal submitted successfully.'
//   //       }),
//   //     error: () => this.messageService.add({
//   //         severity: 'error', summary: 'Error', detail: 'Unable to submit proposal IRA action.'
//   //       })
//   //   });
//   //   this.subscriptions.add(sub);
//   // }

//    submitIRA(): void {
//     if (!this.step_details?.id) return;
//     const payload = {
//       proposal_step: this.step_details.id,
//       approve_status: 1,
//       remark: '',
//       final_approval: this.confirmChecked ? 1 : 0
//     };
//     const sub = this.api.postAPI(`/transaction/copy/proposal-ira-action/`, payload).subscribe({
//       next: (res: any) =>{ this.messageService.add({
//           severity: 'success', summary: 'Success', detail: res?.message || 'Proposal submitted successfully.'
//         })
//         this.transHeaderSteperComponent?.setChangeProposal(parseInt(this.step_details.id));
//         this.confirmChecked = false;
//       },
//       error: () => this.messageService.add({
//           severity: 'error', summary: 'Error', detail: 'Unable to submit proposal IRA action.'
//         })
//     });
//     this.subscriptions.add(sub);
//   }
//    isEditable: boolean = false;
//    step_details: any;

//    getpermDetails() {
//      const user_role_id = sessionStorage.getItem('user_role_id');
//      let seq = parseInt(this.stapName?.sequence)
//      const sub = this.api.getAPI(`/transaction/copy/proposals/${this.proposalId}/steps/?role_id=${user_role_id}`)
//        .subscribe((res: any) => {
//          this.step_details = res[seq - 1];
//            const role = sessionStorage.getItem('user_role_id');

//          this.isEditable = (
//            ((this.step_details.is_initiator || this.step_details.is_approver || this.step_details.is_recommender) &&
//            this.step_details.can_edit)|| role == '6'
//          );
//        });
//      this.subscriptions.add(sub);
//    }

//    generatePDF(event: any) {
//      this.pdfdata = event;
//      this.displayDialog = true;
//    }

//    isHTMLorText(input: any) {
//      const doc = new DOMParser().parseFromString(input, 'text/html');
//      // If the input contains HTML tags, return true (HTML), else false (Plain text)
//      return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
//    }
//    saveVersion() {
//      const data = document.getElementById('printSection')?.innerHTML;

//      if (!data) {
//        console.error("Missing required data for saving version.");
//        return;
//      }
//      const payload = {
//        proposal_step: this.stapName.id,
//        name: this.DocName,
//        paragraph: data
//      };

//      const sub = this.api.postAPI(this.pdfdata.url, payload).subscribe({
//        next: (res) => {
//          this.DocName = ''
//          this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Version saved successfully' });
//        },
//        error: (err) => {
//          console.error("Error saving version:", err);
//        }
//      });
//      this.subscriptions.add(sub);
//    }

//    ongetmasterData() {
//      const sub = this.api.getAPI(`/master/master-data/`).subscribe((res: any) => {
//        this.MasterData = res.data;
//        this.MasterData = this.MasterData.map(item => ({
//          id: item.id,
//          name: item.name,
//          paragraph_1: item.paragraph_1,
//          paragraph_2: item.paragraph_2,
//          style:item.css_file_url,
//          criteria_list: JSON.stringify(item.criteria_list, null, 2) // pretty JSON format
//        }));
//      });
//      this.subscriptions.add(sub);
//    }
//    pdfconvert(htmlContent: string): void {
//      const blob = new Blob([htmlContent], { type: 'text/html' });

//      const url = window.URL.createObjectURL(blob);

//      const anchor = document.createElement('a');
//      anchor.href = url;
//      anchor.download = 'report.html'; // Or give dynamic filename
//      anchor.click();

//      // Cleanup
//      window.URL.revokeObjectURL(url);
//    }
//      getStepNumber(step: any): number {
//     let count = 0;
//     for (let s of this.steps) {
//       if (!s.skipped) {
//         count++;
//       }
//       if (s === step) {
//         return count;
//       }
//     }
//     return 0; // fallback
//   }
//   canNavigateTo(step: any): boolean {
//   if (step.code === this.activeIndexCode) {
//     return true; // current step is clickable (but will do nothing)
//   }

//   return this.isStepCompleted(step); // only completed steps
// }


// onStepClick(step: any): void {
//   if (step.code === this.activeIndexCode) {
//     return; // do nothing if clicking on current step
//   }

//   if (this.isStepCompleted(step)) {
//     // this.navigateToStep(step); // only backward allowed
//      this.onActiveIndexChange(step)
//   }
// }

// // isStepCompleted(step: any): boolean {
// //   const currentIndex = this.steps.findIndex(s => s.code === this.activeIndexCode);
// //   const stepIndex = this.steps.findIndex(s => s.code === step.code);

// //   return stepIndex < currentIndex; // step is before current → completed
// // }

// navigateToStep(step: any): void {

//   if (step.code === this.activeIndexCode) {
//     return; // current step - do nothing
//   }

//   if (!this.isStepCompleted(step)) {
//     return; // future step - prevent navigation
//   }
//   this.activeIndexCode = step.code;
// }
//  displayDialogN = false;
//   shareType: string | null = null;
//    selectedUserN: any;
//   permissionType: string | null = null;
//   selectedUnit: any;
//   internalComment:string
//   externalComment:string
//     openDialog() {
//     this.displayDialogN = true;
//     this.getUserListN();
//     this.getUnit()
//     this.resetForm();
//   }
//   userListN:any
//   getUserListN() {
//   const unitId = Number(sessionStorage.getItem('unit_id'));

//   const sub = this.api.getAPI('/account/users/').subscribe((res: any) => {
//    let user = res.data;

//     // Filter based on unit_id
//     this.userListN = user.filter((user: any) => {
//       return user.unit?.id === unitId;
//     });
//   });

//   this.subscriptions.add(sub);
// }

//     resetForm() {
//     this.shareType = null;
//     this.selectedUserN = null;
//     this.permissionType = null;
//     this.selectedUnit = null;
//   }
// saveSelection() {
//   const payload: any = {
//     proposal_step: this.stapName.id, // Ensure this is defined in your component
//     is_final_approve: false,
//     route_type: this.shareType
//   };

//   if (this.shareType === 'internal') {
//     payload.user = this.selectedUserN?.id;
//     payload.unit = this.selectedUserN?.unit?.id || null; // if needed
//     payload.flag = 1;
//     payload.permission_type = this.permissionType;
//     payload.remark = this.internalComment
//   }

//   if (this.shareType === 'external') {
//     payload.unit = this.selectedUnit?.id ? [this.selectedUnit.id] : [];
//      payload.remark = this.externalComment
//   }

//   console.log('Payload to submit:', payload);

//   const sub = this.api.postAPI('/transaction/copy/proposal-workflow/', payload).subscribe({
//     next: (res) => {
//      this.getworkflowlogs()
//       // Optionally close dialog or show success
//       this.displayDialogN = false;
//       this.routeConfigExpanded = true
//     },
//     error: (err) => {
//       console.error('Error submitting workflow:', err);
//       // Handle errors appropriately
//     }
//   });

//   this.subscriptions.add(sub);
// }
// currentIndex = 0; // or bind it dynamically

// get visibleSteps() {
//   return this.filteredSteps?.slice(this.startIndex, this.startIndex + this.windowSize) || [];
// }

// navigate(direction: number) {
//   const newIndex = this.currentIndex + direction;

//   if (newIndex < 0 || newIndex >= this.filteredSteps.length) return;

//   this.currentIndex = newIndex;
//   this.activeIndexCode = this.filteredSteps[newIndex].code;
//   this.onActiveIndexChange(this.filteredSteps[newIndex]);

//   // Move the window forward if needed
//   if (this.currentIndex >= this.startIndex + this.windowSize) {
//     this.startIndex = this.currentIndex - this.windowSize + 1;
//   }

//   // Move the window backward if needed
//   if (this.currentIndex < this.startIndex) {
//     this.startIndex = this.currentIndex;
//   }
// }


// isCurrent(step: any): boolean {
//   return this.activeIndexCode === step.code;
// }

// isStepCompleted(step: any): boolean {
//   if (!step) return false;

//   const currentIndex = this.steps.findIndex(s => s.code === this.activeIndex);
//   const stepIndex = this.steps.findIndex(s => s.code === step.code);

//   // Step is completed only if it's before the current step AND approved
//   return stepIndex < currentIndex && step.step_status === 'approved';
// }
//  expandedItems: { [key: number]: boolean } = {};
//   animatedNodes: Set<number> = new Set();
//   selectedNode: TimelineItem | null = null;

//   // Sample data
//   timelineData: TimelineItem[] = [];
//   /** Gets the PrimeNG icon class for the status. */
//   getStatusIconClass(status: TimelineItem['status']): string {
//     switch (status) {
//       case 'completed':
//         return 'pi pi-check-circle'; // CheckCircle
//       case 'working':
//         return 'pi pi-spinner pi-spin'; // Activity / Spinner
//       case 'pending':
//         return 'pi pi-history'; // Clock
//       default:
//         return 'pi pi-history';
//     }
//   }

//   /** Gets Bootstrap color class for the node background/border (Custom SCSS needed for exact gradients/shadows). */
//   getStatusColorClass(status: TimelineItem['status'], userType: TimelineItem['userType']): string {
//     // This uses Bootstrap color names for approximation
//     if (userType === 'external') {
//       switch (status) {
//         case 'completed': return 'timeline-node-success'; // Emerald/Green
//         case 'working': return 'timeline-node-primary'; // Blue
//         case 'pending': return 'timeline-node-secondary'; // Slate/Gray
//         default: return 'timeline-node-secondary';
//       }
//     } else { // internal
//       switch (status) {
//         case 'completed': return 'timeline-node-purple'; // Violet/Purple
//         case 'working': return 'timeline-node-indigo'; // Indigo/Dark Blue
//         case 'pending': return 'timeline-node-dark'; // Dark Slate/Gray
//         default: return 'timeline-node-dark';
//       }
//     }
//   }

//   /** Gets Bootstrap badge color class for status badges. */
//   getStatusBadgeColorClass(status: TimelineItem['status']): string {
//     switch (status) {
//       case 'completed': return 'bg-success-subtle text-success-emphasis border border-success-subtle';
//       case 'working': return 'bg-primary-subtle text-primary-emphasis border border-primary-subtle';
//       case 'pending': return 'bg-secondary-subtle text-secondary-emphasis border border-secondary-subtle';
//       default: return 'bg-secondary-subtle text-secondary-emphasis border border-secondary-subtle';
//     }
//   }

//   /** Gets Bootstrap badge color class for priority badges. */
//   getPriorityColorClass(priority: TimelineItem['priority']): string {
//     switch (priority) {
//       case 'critical': return 'bg-danger text-white';
//       case 'high': return 'bg-warning text-dark';
//       case 'medium': return 'bg-info text-dark';
//       case 'low': return 'bg-success text-white';
//       default: return 'bg-secondary text-white';
//     }
//   }

//   /** Gets custom connector SCSS class. */
//   getConnectorClass(currentStatus: TimelineItem['status'], index: number, total: number): string {
//     if (index === total - 1) return '';

//     switch (currentStatus) {
//       case 'completed': 
//         return 'timeline-connector connector-completed';
//       case 'working': 
//         return 'timeline-connector connector-working';
//       default: 
//         return 'timeline-connector connector-pending';
//     }
//   }

//   /** Formats the timestamp. */
//   formatTimestamp(timestamp: string | null): string {
//     if (!timestamp) return 'Pending';
//     const date = new Date(timestamp);
//     return date.toLocaleDateString('en-US', { 
//       month: 'short', 
//       day: 'numeric',
//       year: '2-digit'
//     }) + ' • ' + date.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
//   }

//   /** Toggles the expanded state of an item. */
//   toggleExpanded(id: number): void {
//     this.expandedItems[id] = !this.expandedItems[id];
//   }

// handleNodeClick(item: TimelineItem): void {
//   this.selectedNode = this.selectedNode?.id === item.id ? null : item;
// }

//   /** Calculates overall progress percentage. */
//   getProgressPercentage(): number {
//     const completed = this.timelineData.filter(item => item.status === 'completed').length;
//     return Math.round((completed / this.timelineData.length) * 100);
//   }
//   closeModal(): void {
//   this.selectedNode = null;
// }

//   getworkflowlogs(){
//     this.api.getAPI(`/transaction/timeline/?proposal_step=${this.stapName.id}`)
//     .subscribe((res: any) => {
//       console.log(res)
//        this.timelineData = res.data.map((item: any) => ({
//         ...item,
//         description: `User type: ${item.userType}, Status: ${item.status}`,  // Optional fallback
//         priority: this.getPriorityFromRole(item.internalUsers?.[0]?.role),   // You can define this method
//       }));
//     });
// }
// getPriorityFromRole(role: string): string {
//   if (!role) return '';
//   if (role.includes('Edit')) return 'High';
//   if (role.includes('Comment')) return 'Medium';
//   return 'Low';
// }
//  routeConfigExpanded: boolean = false;
// startIndex = 0;          
// windowSize = 3; 
//   getTabs() {
//     const sub = this.api
//       .getAPI(`/master/scheme/${this.schemeId}/phases/`)
//       .subscribe((res) => {
//         this.tabList = res;
//         this.activePhaseId = this.tabList[0].id;
//         // this.getProposal();
//       });
//     this.subscriptions.add(sub);
//   }
//    onTabChange(event: any): void {
//     this.activeTabIndex = event.index;
//     this.currentPage = 1;
//     this.activePhaseId = this.tabList[event.index]?.id;
//     this.selectedPhaseId = this.tabList[event.index]?.id;
//     // this.getProposal();
//   }
//   showConfirm(): void {
//     this.messageService.add({
//       key: 'confirm',
//       sticky: true,
//       severity: 'info',
//       summary: 'Are you sure you want to submit this proposal?'
//     });
//   }
//   submitProposal(action: 1 | 2): void {
// this.needGenrationComponent?.onSubmit();
// this.rfiComponent?.onSubmit();
// this.vendorComponent?.onSubmit();
// this.draftSocComponent?.onSubmit();
// this.vcnsApprovalComponent?.onSubmit();
// this.aip?.onSubmit();
// this.receiptMomComponent?.onSubmit();
// this.constituteCommitteeComponent?.onSubmit();
// this.feasibiltyStudyComponent?.onSubmit();
// this.psqrComponent?.onSubmit();
// this.aonComponent?.onSubmit();
// this.eoiComponent?.submitStep();
// this.preRfpMeetingComponent?.onSubmit();
// this.firmResponseSubmissionComponent?.onSubmit();
// this.idexPrototypeComponent?.onSubmitMake();
// this.ssctComponent?.onSubmit();
// this.staffEvaluationComponent?.onSubmit();
// this.psqrToSqrComponent?.onSubmit();
// this.idexCommercialRfpComponent?.onRFPSubmit();
// this.commercialNegocatitionComponent?.onSubmit();


//     this.messageService.clear('confirm');
//     if (action === 2) this.submitIRA();
//     this.transHeaderSteperComponent?.getWorkflowLogs();
//   }

//   currentStepChange(event: any): void {
//     this.step_details = event;
//   }

//   checkIsNextRouteConfig(): boolean {
//     const t = this.api.getData() || [];
//     const currentIndex = t.findIndex((s: any) => s?.status === 'working');
//     if (currentIndex === -1) return false;
//     if (currentIndex < t.length - 1) {
//       const nextDirect = t[currentIndex + 1];
//       if ((nextDirect?.permission ?? '') === 'edit') return true;
//     }
//     const curr = t[currentIndex];
//     if (curr?.hasInternal && Array.isArray(curr.internalUsers) && curr.internalUsers.length) {
//       const internalIndex = curr.internalUsers.findIndex((u: any) => u?.status === 'working');
//       if (internalIndex !== -1 && internalIndex < curr.internalUsers.length - 1) {
//         // return (curr.internalUsers[internalIndex + 1]?.permission ?? '') === 'edit';
//         const hasNextInternalEdit = curr.internalUsers.slice(internalIndex + 1).some((u: any) => (u?.permission ?? '') === 'edit');
//       if (hasNextInternalEdit) return true;
//       }
//     }
//     return false;
//   }
//   trigarFromChild(): void {
//     this.messageService.clear('confirm');
//     this.transHeaderSteperComponent?.openDialog();
//     this.transHeaderSteperComponent?.giveTheRouteconfigAccess();
//   }
// }
// interface InternalUser {
//   name: string;
//   status: 'completed' | 'working' | 'pending';
//   timestamp: string | null;
//   role: string;
//   duration: string | null;
//    permission:string;
// }
// interface TimelineItem {
//   id: number;
//   name: string;
//   userType: 'external' | 'internal';
//   status: 'completed' | 'working' | 'pending';
//   timestamp: string | null;
//   description: string;
//   priority: 'critical' | 'high' | 'medium' | 'low';
//   duration: string | null;
//   hasInternal?: boolean;
//   internalUsers?: InternalUser[];
//   unit:string

// }

import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { Subscription } from 'rxjs';
import { TransHeaderSteperComponent } from '../../components/trans-header-steper/trans-header-steper.component';
import { Table } from 'primeng/table';
import { NeedGenrationComponent } from '../stape-component/need-genration/need-genration.component';
import { RFiComponent } from '../stape-component/rfi/rfi.component';
import { VendorComponent } from '../stape-component/vendor/vendor.component';
import { DraftSocComponent } from '../stape-component/draft-soc/draft-soc.component';
import { VcnsApprovalComponent } from '../stape-component/vcns-approval/vcns-approval.component';
import { AIPComponent } from '../stape-component/aip/aip.component';
import { ReceiptMomComponent } from '../stape-component/receipt-mom/receipt-mom.component';
import { ConstituteCommitteeComponent } from '../stape-component/constitute-committee/constitute-committee.component';
import { FeasibiltyStudyComponent } from '../feasibilty-study/feasibilty-study.component';
import { PsqrComponent } from '../psqr/psqr.component';
import { AONComponent } from '../stape-component/aon/aon.component';
import { EOIComponent } from '../stape-component/eoi/eoi.component';
import { PreRfpMeetingComponent } from '../stape-component/pre-rfp-meeting/pre-rfp-meeting.component';
import { FirmResponseSubmissionComponent } from '../firm-response-submission/firm-response-submission.component';
import { IdexPrototypeComponent } from '../idex-prototype/idex-prototype.component';
import { SsctComponent } from '../ssct/ssct.component';
import { StaffEvaluationComponent } from '../staff-evaluation/staff-evaluation.component';
import { PsqrToSqrComponent } from '../psqr-to-sqr/psqr-to-sqr.component';
import { IdexCommercialRfpComponent } from '../idex-commercial-rfp/idex-commercial-rfp.component';
import { CommercialNegocatitionComponent } from '../stape-component/commercial-negocatition/commercial-negocatition.component';
import { PreBidComponent } from '../stape-component/pre-bid/pre-bid.component';
import { SanctionOrderComponent } from '../stape-component/sanction-order/sanction-order.component';
import { ShortlistingOfDasComponent } from '../shortlisting-of-das/shortlisting-of-das.component';
import { UploadDrawingsComponent } from '../upload-drawings/upload-drawings.component';
import { RfpDetailsComponent } from '../stape-component/rfp-details/rfp-details.component';
import { BanchmarkComponent } from '../stape-component/banchmark/banchmark.component';
import { FinalOfferComponent } from '../stape-component/final-offer/final-offer.component';

@Component({
  selector: 'app-make-ii-transaction',
  standalone: false,
  templateUrl: './make-ii-transaction.component.html',
  styleUrl: './make-ii-transaction.component.scss'
})
export class MakeIiTransactionComponent implements OnInit, OnDestroy {
  @ViewChild('dt') documentTable!: Table;
  @ViewChild(TransHeaderSteperComponent) transHeaderSteperComponent?: TransHeaderSteperComponent;
  @ViewChild(NeedGenrationComponent) needGenrationComponent?: NeedGenrationComponent;
  @ViewChild(RFiComponent) rfiComponent?: RFiComponent;
  @ViewChild(VendorComponent) vendorComponent?: VendorComponent;
  @ViewChild(DraftSocComponent) draftSocComponent?: DraftSocComponent;
  @ViewChild(VcnsApprovalComponent) vcnsApprovalComponent?: VcnsApprovalComponent;
  @ViewChild(AIPComponent) aip?: AIPComponent;
  @ViewChild(ReceiptMomComponent) receiptMomComponent?: ReceiptMomComponent;
  @ViewChild(ConstituteCommitteeComponent) constituteCommitteeComponent?: ConstituteCommitteeComponent;
  @ViewChild(FeasibiltyStudyComponent) feasibiltyStudyComponent?: FeasibiltyStudyComponent;
  @ViewChild(PsqrComponent) psqrComponent?: PsqrComponent;
  @ViewChild(AONComponent) aonComponent?: AONComponent;
  @ViewChild(EOIComponent) eoiComponent?: EOIComponent;
  @ViewChild(PreRfpMeetingComponent) preRfpMeetingComponent?: PreRfpMeetingComponent;
  @ViewChild(FirmResponseSubmissionComponent) firmResponseSubmissionComponent?: FirmResponseSubmissionComponent;
  @ViewChild(IdexPrototypeComponent) idexPrototypeComponent?: IdexPrototypeComponent;
  @ViewChild(SsctComponent) ssctComponent?: SsctComponent;
  @ViewChild(StaffEvaluationComponent) staffEvaluationComponent?: StaffEvaluationComponent;
  @ViewChild(PsqrToSqrComponent) psqrToSqrComponent?: PsqrToSqrComponent;
  @ViewChild(IdexCommercialRfpComponent) idexCommercialRfpComponent?: IdexCommercialRfpComponent;
  @ViewChild(CommercialNegocatitionComponent) commercialNegocatitionComponent?: CommercialNegocatitionComponent;
  @ViewChild(PreBidComponent) preBidComponent?: PreBidComponent;
  @ViewChild(SanctionOrderComponent) sanctionOrderComponent?: SanctionOrderComponent;
  @ViewChild(ShortlistingOfDasComponent) shortlistingOfDas?: ShortlistingOfDasComponent;
  @ViewChild(UploadDrawingsComponent) uploadDrawings?: UploadDrawingsComponent;
  @ViewChild(RfpDetailsComponent) rfpDetails?: RfpDetailsComponent;
  @ViewChild(BanchmarkComponent) benchmark?: BanchmarkComponent;
  @ViewChild(FinalOfferComponent) finalOffer?: FinalOfferComponent;

  role_id = sessionStorage.getItem('user_role_id');
  baseUrl = environment.APIUrl;
  masterData: any[] = [];
  pdfdata: any;
  DocName = '';
  displayDialog = false;
  proposalId!: number | string;
  proposalName = '';
  schemeId!: number | string;
  phaseId!: number | string;
  step_details: any;
  userGuide: string = 'process';
  reportList: any[] = [];
  documentList: any[] = [];
  searchText = '';
  tabList: any[] = [];
  confirmChecked = false;
  isEditable: boolean = false;
  winner: any;
  private subscriptions = new Subscription();

  constructor(
    private api: ApiService,
    private route: ActivatedRoute,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    console.log("step details", this.step_details,this.schemeId)
    const paramsSub = this.route.queryParams.subscribe(params => {
      this.proposalId = params['id'];
      this.proposalName = params['name'] ?? '';
      this.phaseId = params['phase'];
      this.schemeId = params['scheme'];
    });
    this.subscriptions.add(paramsSub);
    this.fetchMasterData();
    this.fetchTabs();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  getReportList(): void {
    if (!this.step_details?.id || !this.proposalId) return;
    this.reportList = [];
    const sub = this.api
      .getAPI(`/revenue/need/version-control/?proposal_step=${this.step_details.id}&proposal_step__proposal=${this.proposalId}`)
      .subscribe({
        next: (res: any) => (this.reportList = res || []),
        error: () => this.messageService.add({
          severity: 'error', summary: 'Error', detail: 'Unable to fetch report versions.'
        })
      });
    this.subscriptions.add(sub);
  }

  // getDocumentList(): void {
  //   if (!this.proposalId || !this.schemeId) return;
  //   this.documentList = [];
  //   const sub = this.api
  //     .getAPI(`/make1/dms/documents/${this.schemeId}/${this.proposalId}/`)
  //     .subscribe({
  //       next: (res: any) => (this.documentList = this.prepareDocumentList(res) || []),
  //       error: () => this.messageService.add({
  //         severity: 'error', summary: 'Error', detail: 'Unable to fetch documents.'
  //       })
  //     });
  //   this.subscriptions.add(sub);
  // }
  getDocumentList() {
    this.documentList = []
    const sub = this.api.getAPI(`/transaction/dms/files/?proposal_step__proposal=${this.proposalId}`).subscribe((res: any) => {
      this.documentList = res.data
    });
    this.subscriptions.add(sub);
  }

  prepareDocumentList(data: any): any[] {
    const docs: any[] = [];
    if (data.need_generation) {
      docs.push({ name: 'Draft SOTR', url: data.need_generation.draft_sotr });
      data.need_generation.need_files?.forEach((file: any, index: number) => {
        docs.push({ name: `Need File ${index + 1}`, url: file.file });
      });
    }
    if (data.aip?.document) docs.push({ name: 'AIP Document', url: data.aip.document });
    if (data.qa_agecy?.nomination_file?.length > 0) {
      data.qa_agecy.nomination_file.forEach((file: any, index: number) => {
        docs.push({ name: `QA Agency File ${index + 1}`, url: file.file });
      });
    }
    if (data.aon_soc) {
      if (data.aon_soc.aon) docs.push({ name: 'AON', url: data.aon_soc.aon });
      if (data.aon_soc.soc) docs.push({ name: 'SOC', url: data.aon_soc.soc });
    }
    if (data.pre_rfp_meeting?.mom) docs.push({ name: 'Pre-RFP Meeting MoM', url: data.pre_rfp_meeting.mom });
    if (data.pre_eoi_meeting?.file) docs.push({ name: 'Pre-EOI Meeting MoM', url: data.pre_eoi_meeting.file });
    if (data.pre_bid_meeting?.mom) docs.push({ name: 'Pre-Bid Meeting MoM', url: data.pre_bid_meeting.mom });
    if (data.final_offer?.offer) docs.push({ name: 'Final Offer', url: data.final_offer.offer });
    if (data.drawings_documents) {
      if (data.drawings_documents.drawing) docs.push({ name: 'Drawing File', url: data.drawings_documents.drawing });
      if (data.drawings_documents.document) docs.push({ name: 'Document File (Drawings)', url: data.drawings_documents.document });
    }
    if (data.qap_atp) {
      if (data.qap_atp.qap) docs.push({ name: 'QAP File', url: data.qap_atp.qap });
      if (data.qap_atp.document) docs.push({ name: 'ATP Document', url: data.qap_atp.document });
    }
    if (data.fats_prototype?.fat_report) docs.push({ name: 'FAT Report', url: data.fats_prototype.fat_report });
    if (data.user_certificate?.certificated) docs.push({ name: 'User Certificate', url: data.user_certificate.certificated });
    if (data.development_prototype?.file) docs.push({ name: 'Development Prototype', url: data.development_prototype.file });
    if (data.user_trials?.signed_documents) docs.push({ name: 'User Trials (Signed Docs)', url: data.user_trials.signed_documents });
    if (data.user_trials_make?.signed_documents) docs.push({ name: 'User Trials (Make)', url: data.user_trials_make.signed_documents });
    if (data.feasibility_study?.file) docs.push({ name: 'Feasibility Study', url: data.feasibility_study.file });
    if (data.bulk_production?.document) docs.push({ name: 'Bulk Production Document', url: data.bulk_production.document });
    return docs;
  }

  pdfconvert(htmlContent: string): void {
    if (!htmlContent) return;
    const blob = new Blob([htmlContent], { type: 'text/html' });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url; anchor.download = 'report.html'; anchor.click();
    window.URL.revokeObjectURL(url);
  }

  // submitIRA(): void {
  //   if (!this.step_details?.id) return;
  //   const payload = {
  //     proposal_step: this.step_details.id,
  //     approve_status: 1,
  //     remark: '',
  //     final_approval: this.confirmChecked ? 1 : 0
  //   };
  //   const sub = this.api.postAPI(`/transaction/copy/proposal-ira-action/`, payload).subscribe({
  //     next: (res: any) => this.messageService.add({
  //         severity: 'success', summary: 'Success', detail: res?.message || 'Proposal submitted successfully.'
  //       }),
  //     error: () => this.messageService.add({
  //         severity: 'error', summary: 'Error', detail: 'Unable to submit proposal IRA action.'
  //       })
  //   });
  //   this.subscriptions.add(sub);
  // }



  comment: string = '';
  submitIRA(): void {
    if (!this.step_details?.id) return;
    const payload = {
      editor_turn: this.step_details.editor_id,
      remarks: this.comment,
    };
    const sub = this.api.postAPI(`/file_mange/editor/approve/`, payload).subscribe(res => {

      if (res.status !== 'Approved') {

        this.transHeaderSteperComponent?.navigate(1, true);
      } else {
        this.transHeaderSteperComponent?.navigate(1, false, true);
      }
    }
    );
    this.subscriptions.add(sub);
  }

  generatePDF(event: any): void {
    this.pdfdata = event; this.displayDialog = true;
  }

  isHTMLorText(input: any): boolean {
    if (typeof input !== 'string') return false;
    const doc = new DOMParser().parseFromString(input, 'text/html');
    return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
  }

  saveVersion(): void {
    const data = document.getElementById('printSection')?.innerHTML;
    if (!data || !this.step_details?.id || !this.pdfdata?.url) {
      console.error('Missing required data for saving version.');
      return;
    }
    const payload = {
      proposal_step: this.step_details.id,
      name: this.DocName || 'Version',
      paragraph: data
    };
    const sub = this.api.postAPI(this.pdfdata.url, payload).subscribe({
      next: res => {
        this.DocName = '';
        this.messageService.add({
          severity: 'success', summary: 'Success', detail: res?.message || 'Version saved successfully.'
        });
      },
      error: () => this.messageService.add({
        severity: 'error', summary: 'Error', detail: 'Unable to save version.'
      })
    });
    this.subscriptions.add(sub);
  }

  private fetchMasterData(): void {
    const sub = this.api.getAPI(`/master/master-data/`).subscribe({
      next: (res: any) => {
        const data = res?.data || [];
        this.masterData = data.map((item: any) => ({
          id: item.id,
          name: item.name,
          paragraph_1: item.paragraph_1,
          paragraph_2: item.paragraph_2,
          style: item.css_file_url,
          criteria_list: JSON.stringify(item.criteria_list, null, 2)
        }));
      },
      error: () => this.messageService.add({
        severity: 'error', summary: 'Error', detail: 'Unable to fetch master data.'
      })
    });
    this.subscriptions.add(sub);
  }

  private fetchTabs(): void {
    if (!this.schemeId) return;
    const sub = this.api.getAPI(`/master/scheme/${this.schemeId}/phases/`).subscribe({
      next: (res: any) => (this.tabList = res || []),
      error: () => this.messageService.add({
        severity: 'error', summary: 'Error', detail: 'Unable to fetch phases.'
      })
    });
    this.subscriptions.add(sub);
  }
  visibleConfirm: boolean = false;
  showConfirm(): void {
    this.messageService.clear('confirm');
    this.messageService.add({
      key: 'confirm',
      sticky: true,
      severity: 'info',
      summary: 'Are you sure you want to submit this proposal?'
    });
    this.visibleConfirm = true;
  }

  submitProposal(action: 1 | 2): void {
    this.needGenrationComponent?.onSubmit();
    this.rfiComponent?.onSubmit();
    this.vendorComponent?.onSubmit();
    this.draftSocComponent?.onSubmit();
    this.vcnsApprovalComponent?.onSubmit();
    this.aip?.onSubmit();
    this.receiptMomComponent?.onSubmit();
    this.constituteCommitteeComponent?.onSubmit();
    this.feasibiltyStudyComponent?.onSubmit();
    this.psqrComponent?.onSubmit();
    this.aonComponent?.onSubmit();
    this.eoiComponent?.submitStep();
    this.preRfpMeetingComponent?.onSubmit();
    this.firmResponseSubmissionComponent?.onSubmit();
    this.idexPrototypeComponent?.onSubmitMake();
    this.ssctComponent?.onSubmit();
    this.staffEvaluationComponent?.onSubmit();
    this.psqrToSqrComponent?.onSubmit();
    this.idexCommercialRfpComponent?.onRFPSubmit();
    this.commercialNegocatitionComponent?.onSubmit();
    this.preBidComponent?.onSubmit();
    this.sanctionOrderComponent?.onSubmit();
    this.shortlistingOfDas?.onSubmit();
    this.uploadDrawings?.onSubmit();
    this.rfpDetails?.onSubmit();
    this.benchmark?.submitProposalData();
    this.finalOffer?.onSubmit();
    this.messageService.clear('confirm');
    if (action === 2) this.submitIRA();
    this.visibleConfirm = false;
    this.transHeaderSteperComponent?.getWorkflowLogs();
  }

  checkIsNextRouteConfig() {
    const t = this.api.getData() || [];


    // current working directorate (top level)
    const currentIndex = t.findIndex(s => (s?.status ?? "") === "working");
    if (currentIndex === -1) return false;

    // 1) current directorate ke internalUsers me (current working user ke baad) koi edit hai kya?
    const curr = t[currentIndex];
    if (curr?.hasInternal && Array.isArray(curr.internalUsers) && curr.internalUsers.length) {
      const internalIndex = curr.internalUsers.findIndex(u => (u?.status ?? "") === "working");

      if (internalIndex !== -1) {
        const hasNextInternalEdit = curr.internalUsers
          .slice(internalIndex + 1)
          .some(u => (u?.permission ?? "") === "edit");

        if (hasNextInternalEdit) return true;
      } else {
        // Agar koi internal "working" marked hi nahi hai, still check any internal edit
        if (curr.internalUsers.some(u => (u?.permission ?? "") === "edit")) return true;
      }
    }

    // 2) currentIndex ke baad ke sabhi next directorates + unke internalUsers me koi edit hai kya?
    for (let i = currentIndex + 1; i < t.length; i++) {
      const next = t[i];

      // next directorate itself has edit
      if ((next?.permission ?? "") === "edit") return true;

      // next directorate ke kisi bhi internal user ke paas edit
      if (next?.hasInternal && Array.isArray(next.internalUsers) && next.internalUsers.length) {
        const anyInternalEdit = next.internalUsers.some(u => (u?.permission ?? "") === "edit");
        if (anyInternalEdit) return true;
      }
    }

    return false;
  }

  // trigarFromChild(): void {
  //   this.transHeaderSteperComponent?.openDialog();
  // }
  trigarFromChild(): void {
    this.messageService.clear('confirm');
    this.transHeaderSteperComponent?.openDialog();
    this.transHeaderSteperComponent?.giveTheRouteconfigAccess();
  }

  currentStepChange(event: any): void {
    this.step_details = event;
  }
  apiResponse: any;
  getReportData(): void {
    this.api.getAPI(`/make1/make2/proposal/report/${this.proposalId}/`).subscribe((res) => {
      this.apiResponse = res;
    });
  }

}
